
<template>
    <el-card shadow="never" class="box-card">
    <div slot="header" class="clearfix">
        <span>{{name}}</span>
    </div>
        <div class="text item paramContainer">
            <el-row :gutter="10">
                <el-col class="paramNameCol" :span="8">
                    URI
                </el-col>
                <el-col :span="16">
                    <el-input
                        type="textarea"
                        placeholder="Please input URI"
                        v-model="target_uris"
                        clearable>
                    </el-input>        
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Search engine URI
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.se_uri"  placeholder="Select mode">
                        <el-option
                        v-for="item in engine"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Suggestions
                </el-col>
                <el-col :span="16">
                     <el-select v-model="model.params.use_suggestions"  placeholder="Select mode">
                        <el-option
                        v-for="item in suggestions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Region
                </el-col>
                <el-col :span="16">
                    <el-input
                        placeholder="Input region (text)"
                        v-model="model.params.lr"
                        clearable>
                    </el-input> 
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Finish task probability
                </el-col>
                <el-col :span="16">
                    <el-input-number
                        maxlength="99"
                        minlengt="0"
                        :step="1"
                        size="mini"
                        v-model="model.params.finish_task_percentage">
                    </el-input-number>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Save image probability
                </el-col>
                <el-col :span="16">
                    <el-input-number
                        maxlength="99"
                        minlengt="0"
                        :step="1"
                        size="mini"
                        v-model="model.params.save_image_percentage">
                    </el-input-number>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col class="paramNameCol" :span="8">
                    Queries
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-input
                    type="textarea"
                    class="textarea-stripe-container"
                    placeholder="Please input search queries"
                    autosize
                    v-model="queries">
                </el-input>
            </el-row>
            <el-collapse v-model="collapso_advanced">
                <el-collapse-item title="Advanced options" name="1">
		            <el-row :gutter="10">
		                <el-col class="paramNameCol" :span="8">
		                    Watch URI
		                </el-col>
		                <el-col :span="16">
		                    <el-input
		                        type="textarea"
		                        placeholder="Please input URI"
		                        v-model="watch_uris"
		                        clearable>
		                    </el-input>
		                </el-col>
		            </el-row>
                </el-collapse-item>
            </el-collapse>
            <el-row>
                <div class="tip">
                    So you can specify what site or image you want to search via Yandex Images.
                </div>
            </el-row>
        </div>
    </el-card>    
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'Yandex',
    props: {
        key: {
            type: Number
        },
        model: {
            type: Object,
            default: () => {}
        },
    },
    data () {
        return {
            name:'Search Images in Yandex',
            engine: [
                {value:'https://ya.ru',     name: 'ya.ru'},
                {value:'direct_url',        name: 'direct url'},
                {value:'browser_widget',    name: 'browser widget'},
                {value:'https://yandex.ru', name: 'yandex.ru'},
                {value:'https://yandex.kz', name: 'yandex.kz'},
                {value:'https://yandex.kg', name: 'yandex.kg'},
                {value:'https://yandex.by', name: 'yandex.by'},
                {value:'https://yandex.uz', name: 'yandex.uz'},
                {value:'https://yandex.com',name: 'yandex.com'},
                {value:'https://yandex.com.tr',name: 'yandex.com.tr'},
            ],
            suggestions: [
                {value:'never', name: 'never'},
                {value:'random', name: 'random'},
                {value:'always', name: 'always'},
            ],
            textarea: '',
            queries: this.prepareParam(this, 'values'),
            target_uris: this.prepareParam(this, 'target_uri'),
            watch_uris: this.prepareParam(this, 'watch_uri'),
        }
    },

    methods: {
    },
    computed: {
        ...mapState('bot', {
        bot: 'bot',
        project: 'project',
        error: 'error',
        loading: 'loading',
        }),
    },
    watch: {
        queries(newValue, oldValue) {
            this.model.params.values = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        target_uris(newValue, oldValue) {
            this.model.params.target_uri = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        watch_uris(newValue, oldValue) {
            this.model.params.watch_uri = newValue.replace(/\r\n/g,"\n").split("\n");
        },
    },
}
</script>